import { Factory } from "../../core/factory";

import { getAxisOption } from "./get-axis-config";

export function getZeroAlignTickAlignTicks(targetRange, col, row, index, position, layout) {
    const getAxisDomainRangeAndLabels = Factory.getFunction("getAxisDomainRangeAndLabels"), {axisOption: axisOption, isZeroAlign: isZeroAlign} = getAxisOption(col, row, 0 === index ? "right" : "left", layout), {ticks: ticks} = getAxisDomainRangeAndLabels(targetRange.min, targetRange.max, axisOption, isZeroAlign, "bottom" === position || "top" === position ? layout._table.getColWidth(col) || layout._table.tableNoFrameWidth : layout._table.getRowHeight(row) || layout._table.tableNoFrameHeight);
    return ticks;
}

export function getTickModeFunction(targetTicks, targetRange, range, indicatorIndex) {
    return 0 !== indicatorIndex && targetTicks ? () => targetTicks.map((value => {
        const percent = (value - targetRange.min) / (targetRange.max - targetRange.min), tick = (range.max - range.min) * percent + range.min;
        return Math.round(100 * tick) / 100;
    })) : void 0;
}
//# sourceMappingURL=tick-align.js.map
